import { useEffect, useMemo } from 'react';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { useOpenSearchContext } from './useOpenSearchContext';
import { buildFacetQueryFilters } from '../utils';
import { useUpdateSearchParams } from './useUpdateSearchParams';

const useBooleanRefinement = ({ attribute }: { attribute: string }) => {
  const { updateQueryFiltersByFacets, queryFiltersByFacets, isLoading } =
    useOpenSearchContext();
  const { updateSearchParams } = useUpdateSearchParams();

  const refinedValue = useMemo(
    () =>
      (
        (queryFiltersByFacets?.[attribute] as QueryContainer)?.bool
          ?.should as QueryContainer[]
      )?.[0]?.match?.[attribute],
    [queryFiltersByFacets],
  );
  const isActive = useMemo(() => !!refinedValue, [refinedValue]);

  useEffect(() => {
    if (queryFiltersByFacets[attribute]) return;
    // If the attribute is not already in the query
    updateQueryFiltersByFacets((prev: Record<string, QueryContainer>) => ({
      ...prev,
      [attribute]: buildFacetQueryFilters(attribute, []),
    }));
  }, [queryFiltersByFacets]);

  const handleRefine = () => {
    const newRefined = refinedValue ? [] : [true];
    updateSearchParams({
      [attribute]: Array.from(newRefined).map(String),
      page: '1',
    });

    updateQueryFiltersByFacets((prev: Record<string, QueryContainer>) => ({
      ...prev,
      [attribute]: buildFacetQueryFilters(attribute, newRefined),
    }));
  };

  return {
    isActive,
    refine: handleRefine,
    isLoading,
  };
};

export { useBooleanRefinement };
